<template>
  <v-text-field
    v-mask="'##/##/####'"
    v-model="displayDate"
    dense
    solo
    v-bind="$attrs"
    @blur="validateDate"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Date, null],
      required: true,
    },
  },
  data() {
    return {
      displayDate: "",
      internalDate: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.displayDate = "";
          this.internalDate = null;
          return;
        }

        // Converte de YYYY-MM-DD para DD/MM/YYYY
        if (typeof newVal === "string" && newVal.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [ano, mes, dia] = newVal.split("-");
          this.displayDate = `${dia}/${mes}/${ano}`;
          this.internalDate = newVal;
        }
        // Se for objeto Date
        else if (newVal instanceof Date) {
          const dia = String(newVal.getDate()).padStart(2, "0");
          const mes = String(newVal.getMonth() + 1).padStart(2, "0");
          const ano = newVal.getFullYear();
          this.displayDate = `${dia}/${mes}/${ano}`;
          this.internalDate = `${ano}-${mes}-${dia}`;
        }
      },
    },
  },
  methods: {
    validateDate() {
      if (!this.displayDate || !this.displayDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        this.$emit("input", null);
        return;
      }

      const [dia, mes, ano] = this.displayDate.split("/");
      const diaNum = parseInt(dia, 10);
      const mesNum = parseInt(mes, 10);

      // Validação básica de data
      if (mesNum > 12 || diaNum > 31 || mesNum < 1 || diaNum < 1) {
        this.$emit("input", null);
        return;
      }

      // Verifica meses com 30 dias
      const meses30 = [4, 6, 9, 11];
      if (meses30.includes(mesNum) && diaNum > 30) {
        this.$emit("input", null);
        return;
      }

      // Verifica fevereiro (considerando não bissexto para simplificar)
      if (mesNum === 2 && diaNum > 28) {
        this.$emit("input", null);
        return;
      }

      const formattedDate = `${ano}-${mes}-${dia}`;
      this.internalDate = formattedDate;
      this.$emit("input", formattedDate);
    },
  },
};
</script>
